import { NgModule } from '@angular/core';
import { NodeService, TnxSharedModule } from 'tnx-shared';
import { StateMachinesFormComponent } from './statemachines-form/statemachines-form.component';
import { StateMachinesComponent } from './statemachines.component';
import { StateMachinesRoutes } from './statemachines.routing';

export function declaration() {
    return [StateMachinesComponent,
        StateMachinesFormComponent
    ];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration(),
    providers: [NodeService]
})
export class StateMachinesModule {
}

@NgModule({
    imports: [StateMachinesModule, StateMachinesRoutes],
    exports: [StateMachinesModule]
})
export class StateMachinesWithRouteModule {
}
